import {tryCall} from '../../utils';

export class AnimationTimer {
	private startedStatus: boolean = false;
	private onStartCallback: Function = () => this.startedStatus = true;
	private onEndCallback: Function = () => this.startedStatus = false;
	private duration: number = 0;
	private timerID: number = 0;
	private animationFrameRequestID: number = 0;

	public get isStarted() {
		return this.startedStatus;
	}

	public cancel(): AnimationTimer {
		clearTimeout(this.timerID);
		this.startedStatus = false;
		return this;
	}

	public onEnd(callback: Function): AnimationTimer {
		const prevCallback = this.onEndCallback;
		this.onEndCallback = () => {
			if (prevCallback && 'call' in prevCallback) {
				tryCall(prevCallback);
			}

			if (callback && 'call' in callback) {
				tryCall(callback);
			}
		};
		return this;
	}

	public onStart(callback: Function): AnimationTimer {
		const prevCallback = this.onStartCallback;
		this.onStartCallback = () => {
			if (prevCallback && 'call' in prevCallback) {
				tryCall(prevCallback);
			}

			if (callback && 'call' in callback) {
				tryCall(callback);
			}
		};
		return this;
	}

	public setDuration(duration: number): AnimationTimer {
		this.duration = duration;
		return this;
	}

	public start(): AnimationTimer {
		if (this.startedStatus) {

		} else {
			this.animationFrameRequestID = requestAnimationFrame(() => {
				this.onStartCallback();
				if (this.duration) {
					this.timerID = window.setTimeout(() => {
						this.animationFrameRequestID = requestAnimationFrame(() => {
							this.onEndCallback();
						});
					}, this.duration);
				} else {
					this.onEndCallback();
				}
			});
		}
		return this;
	}

	public destroy(): void {
		if(this.timerID) {
			clearTimeout(this.timerID);
		}

		if(this.animationFrameRequestID) {
			cancelAnimationFrame(this.animationFrameRequestID);
		}
	}

}
